import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { CompanyDepartmentKeys } from '@aibees/elephant/feature/search-table-company';
import { Nullable } from '@aibees/shared/definition';
import { capitalize } from '@aibees/shared/utils';
import { useMemo } from 'react';
import { DEPARTMENTS_TRANSLATIONS } from './utils';

export function humanReadableDepartment(key?: Nullable<CompanyDepartmentKeys>) {
  if (!key) return '';
  return DEPARTMENTS_TRANSLATIONS[key] ?? capitalize(key.replaceAll('_', ' '));
}

export type Department = {
  label: string;
  value: string;
};

export function useCompanyMetrics() {
  const { api } = useCompanyReadDataContext();

  return useMemo(() => {
    if (!api?.data)
      return {
        metrics: undefined,
        departments: [],
        allDepartments: [],
        hasDepartments: false,
      };

    const metrics = api?.data?.analytics?.linkedin?.metrics
      ?.filter((x) => !!x.start_date)
      .map((x) => ({
        ...x,
        ...{
          startDate: new Date(x.start_date!).getTime(),
          departments: x.departments,
        },
      }));

    const departments: Department[] =
      metrics?.at(0)?.departments.map((x) => ({
        label: humanReadableDepartment(x.functions),
        value: x.functions ?? 'all',
      })) ?? [];

    const allDepartments = Object.keys(DEPARTMENTS_TRANSLATIONS).map((key) => ({
      label: humanReadableDepartment(key as Nullable<CompanyDepartmentKeys>),
      value: key,
    }));

    const hasDepartments = departments.length > 0;

    return { metrics, departments, allDepartments, hasDepartments };
  }, [api?.data]);
}
